/* globals $ */

class Tooltips {
  constructor() {
    $("body").click(() => {
      $(".tooltip").fadeOut("fast");
    });
  }

  init($elem) {
    $.each($elem, (i, elem) => {
      $elem = $(elem);
      let $for = $($elem.data("for"));
      if ($for.length) {
        $elem.hover(
          () => {
            if ($(window).width() > 1024) {
              this.show($for);
            }
          },
          () => {
            if ($(window).width() > 1024) {
              this.hide($for);
            }
          },
        );
        $elem.click((e) => {
          e.preventDefault();
          e.stopPropagation();
          if ($(window).width() <= 1024) {
            this.toggle($for);
          }
        });
      }
    });
  }

  show($elem) {
    $elem.addClass("show");
  }

  hide($elem) {
    $elem.removeClass("show");
  }

  toggle($elem) {
    if ($elem.hasClass("show")) {
      this.hide($elem);
    } else {
      this.show($elem);
    }
  }
}

export { Tooltips };
